exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@-moz-document url-prefix(){[layout-fill]{margin:0;width:100%;min-height:100%;height:100%}}div{background-color:#fff}div .qas-icon-footer{position:absolute;left:0;width:150px;height:20px}div p.mat-caption{margin:5px}", ""]);

